import { TrendingUp } from "lucide-react";
import OptimizedAnalytics from "@/components/dashboard/analytics/OptimizedAnalytics";
import { ErrorCard } from "../layout/ErrorCard";
interface AnalyticsWidgetProps {
  isLoading: boolean;
  error: any;
  onRetry: () => void;
}
export const AnalyticsWidget = ({
  isLoading,
  error,
  onRetry
}: AnalyticsWidgetProps) => {
  return <section>
      
      {error ? <ErrorCard onRetry={onRetry} /> : <OptimizedAnalytics />}
    </section>;
};